import { Flex, SimpleGrid, GridItem } from "@chakra-ui/react"

import CustomerSiteArchive from "./CustomerSiteArchive"
import { useNavigate } from "react-router-dom"
import { useRoute } from "@hydrologiq/shared/providers/helpers/useRoute"

const CustomerSiteAdmin = ({ site, customer }: { site?: string; customer?: string }) => {
  const navigate = useNavigate()
  let route = useRoute()
  route = route.endsWith("/") ? route : `${route}/`

  return (
    <SimpleGrid columns={{ base: 2 }} gap={5} marginBottom={5}>
      <GridItem>
        <Flex justifyContent={"space-between"} width={"fit-content"} gap={5} flexWrap={"wrap"}>
          {customer && site && (
            <CustomerSiteArchive
              customer={customer}
              site={site}
              onSiteRemoved={() => {
                navigate(`${route}${customer}`)
              }}
            />
          )}
        </Flex>
      </GridItem>
    </SimpleGrid>
  )
}

export default CustomerSiteAdmin
